var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.pageLoading),expression:"pageLoading"}],attrs:{"id":"app"}},[_c('keep-alive',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }